import { AbsenceLimitCalcTypeEnum } from "src/app/models/enums/absence-limit-calc-type-enum";
import { Moment } from 'moment';

export function equivalentHourlyAbsenceLimitCalcFunc(days: number): number {
  if (days <= 0) return 0;

  let points = 0;

  for (let day = 1; day <= days; day++) {
    if (day % 5 === 0) {
      points += 3;
    } else {
      points += 1;
    }
  }

  return points;
}

export function baseAbsenceLimitCalcFunc(areWeekendsDaysOff: boolean, daysOff: Date[], diff: number, endDate: Moment, startDate: Moment, absenceLimitCalcType: AbsenceLimitCalcTypeEnum, ignoreCalendarValidation = false) {
  if (ignoreCalendarValidation) {
    return endDate.diff(startDate, 'days');
  }

  if (!areWeekendsDaysOff && !daysOff) {
    diff = endDate.diff(startDate, 'days');
  } else {
    diff = 0;
    var date = startDate.toDate();

    while (date <= endDate.toDate()) {
      if (date.isWorkingDay(areWeekendsDaysOff, daysOff, absenceLimitCalcType)) {
        diff++;
      }

      date = date.addDays(1);
    }
  }
  return diff;
}

export function formatAbsence(fullDays: number, hours: number): string {
  if ((!fullDays && !hours) || (fullDays === 0 && hours === 0)) return '-';
  if (fullDays && !hours) return `${fullDays}d`;
  if (!fullDays && hours) return `${hours}h`;
  return `${fullDays}d ${hours}h`;
}
